var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ScrollToSelected",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>back to top button playlist</title>
  <g id="svg-fg">
    <path d="M34.27,32.23c0,.65,0,1.19,0,1.73q0,5.85,0,11.71a2.28,2.28,0,1,1-4.56,0q0-6.42,0-12.85v-.59l-.35.33c-1.19,1.19-2.37,2.38-3.57,3.56a2.27,2.27,0,0,1-2.75.32A2.2,2.2,0,0,1,22,34a2.93,2.93,0,0,1,.68-1.15q3.81-3.87,7.67-7.7a2.25,2.25,0,0,1,3.26,0l7.68,7.7a2.27,2.27,0,0,1-1.36,3.94,2.22,2.22,0,0,1-1.82-.69l-3.47-3.47Z"/>
    <circle cx="32" cy="18.25" r="2.25"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/scroll_to_selected.svg